// extracted by mini-css-extract-plugin
export default {"container":"Index_container__WLtCb","header":"Index_header__QrrVU","uqbarlogo":"Index_uqbarlogo__ARf+H","discordlogo":"Index_discordlogo__M4CTp","navbar":"Index_navbar__4doZR"};